import { COLORS } from 'helpers/globals'

const star = {
  fontSize: '3rem',
  color: COLORS.secondary,
  cursor: 'pointer'
}

export default {
  favorite: {
    position: 'absolute',
    right: '.7rem',
    top: 0
  },
  favorited: {
    ...star,
    color: COLORS.gold
  },
  notFavorited: star,
  tooltip: {
    position: 'absolute',
    width: 120,
    right: 0,
    textAlign: 'center',
    background: COLORS.tertiary
  }
}



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/CameraDetailsContainer/CameraDetails/Favorite/style.js